import { ReactNode } from "react";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { SkipLink } from "@/components/common/SkipLink";
// import { Analytics } from "@/components/seo/Analytics";
import { SEO } from "@/components/seo/SEO";
import { CookieConsent } from "@/components/common/CookieConsent";
import { Toaster } from "@/components/ui/toaster";
import { StickyCTA } from "@/components/common/StickyCTA";
import { WhatsAppButton } from "@/components/common/WhatsAppButton";
import { useTranslation } from "react-i18next";

interface LegalLayoutProps {
  title: string;
  description?: string;
  path: string;
  children: ReactNode;
}

export const LegalLayout = ({ title, description, path, children }: LegalLayoutProps) => {
  const { i18n } = useTranslation();
  const isTurkish = i18n.language?.startsWith("tr");

  return (
    <div className="bg-neutral-50 min-h-screen text-neutral-900 flex flex-col">
      <SkipLink />
      <SEO title={title} description={description} url={path} />
      // Analytics centralized in App.tsx; removed unused import
      <Header />
      <main id="main-content" className="flex-grow">
        <div className="container mx-auto px-4 py-16 max-w-5xl">
          <header className="mb-12">
            <h1 className="text-4xl font-bold text-neutral-900">{title}</h1>
            {description ? (
              <p className="mt-4 text-lg text-neutral-600">{description}</p>
            ) : null}
          </header>
          <div className="prose prose-neutral prose-lg max-w-none">
            {!isTurkish ? (
              <div className="mb-8 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900">
                This document is currently available in Turkish. For assistance or an official copy in another language,
                please contact <a href="mailto:info@insorganizasyon.org" className="underline">info@insorganizasyon.org</a>.
              </div>
            ) : null}
            {children}
          </div>
        </div>
      </main>
      <Footer />
      <CookieConsent />
      <Toaster />
      <StickyCTA />
      <WhatsAppButton />
    </div>
  );
};
